export default __webpack_public_path__ + "static/media/ic_bought.ca1ed9eb.svg";